import script from "./PbxBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxBadge.vue?vue&type=script&setup=true&lang=js"

import "./PbxBadge.vue?vue&type=style&index=0&id=36b86130&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b86130"]])

export default __exports__